<button (click)="toggle()" matRipple aria-current="page" [matTooltip]="tooltip" [disabled]="disabled"
    class="inline-flex h-9 min-w-9 shrink-0 items-center justify-center gap-1 rounded-md px-2.5 text-sm font-medium transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-40"
    [ngClass]="value
        ? 'bg-green-500 bg-opacity-80 text-white ring-1 ring-green-500 ring-opacity-40 shadow-sm'
        : 'bg-white bg-opacity-70 text-slate-700 ring-1 ring-slate-300 ring-opacity-70 hover:bg-opacity-95 hover:text-slate-900'">

    <ng-container *ngIf="value; else offTemplate">
        <fa-icon [icon]="onIcon" class="align-middle icon-size-4"></fa-icon>
        {{textOn}}
    </ng-container>

    <ng-template #offTemplate>
        <fa-icon [icon]="offIcon" class="align-middle icon-size-4"></fa-icon>
        {{textOff}}
    </ng-template>

</button>
